import React, {useEffect, useState} from "react";
import TrackList from "./TrackList";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet"
import rootDir from "../..";

interface Props {
    albumData: any;
    myRegion: string;
    searchRegion: string;
}

const AlbumDetail = ({albumData, myRegion, searchRegion }: Props) => {
    const [currentUrl, setCurrentUrl] = useState<string>('');

    useEffect(() => {
        setCurrentUrl(window.location.href)
    }, []);
    return (
        <table id="AlbumDetails">
            <Helmet>
                <title>{`Rocksmith+ Album Detail: `+albumData.album_title+` by `+albumData.album_artist}</title>
                <meta name="keywords" content={"album detail, "+albumData.album_title+", "+albumData.album_artist} />
                <meta name="description" content={"Rocksmith+ album detail for "+albumData.album_title+" by "+albumData.album_artist} />
                <meta property="og:title" content={"Rocksmith+ Album Detail: "+albumData.album_title+" by "+albumData.album_artist}/>
                <meta property="og:image" content={albumData.album_cover}/>
                <meta property="og:url" content={currentUrl}/>
                <meta property="og:description" content={"Rocksmith+ song detail for "+albumData.album_title+" by "+albumData.album_artist}/>
                <meta name="twitter:title" content={"Rocksmith+ Album Detail: "+albumData.album_title+" by "+albumData.album_artist} />
                <meta name="twitter:description" content={"Rocksmith+ song detail for "+albumData.album_title+" by "+albumData.album_artist}/>
                <meta name="twitter:image" content={albumData.album_cover} />
            </Helmet>
            <thead>
                <tr>
                    <th colSpan={6} title={albumData ? albumData.ID : null}>Album Details</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td rowSpan={6} height={300} width={300}>{albumData.album_cover ? <img src={albumData.album_cover} height={300} alt="Cover" title="Album cover" /> : null}</td>
                    <td>Title:</td>
                    <td>{albumData.album_title ? albumData.album_title : null}</td>
                </tr>
                <tr>
                    <td>Artist:</td>
                    <td>{albumData.album_artist_id ? <Link to={rootDir+'artist/'+albumData.album_artist_id} >{albumData.album_artist}</Link> : null}</td>
                </tr>
                <tr>
                    <td>Year:</td>
                    <td>{albumData.album_year ? albumData.album_year : null} { albumData.album_type ? <span>({albumData.album_type})</span> : null}</td>
                </tr>
                <tr>
                    <td># of Songs:</td>
                    <td>{albumData ? albumData.no_of_tracks : null}</td>
                </tr>
                <tr>
                    <td>Time:</td>
                    <td>{albumData ? albumData.time : null}</td>
                </tr>
                <tr>
                    <td>Label:</td>
                    <td>{albumData ? albumData.album_label : null}</td>
                </tr>
                <tr>
                    <td colSpan={6}><TrackList trackData={albumData.tracks} myRegion={myRegion} searchRegion={searchRegion} displayPage={'album'} /></td>
                </tr>
            </tbody>
        </table>
    )
}

export default AlbumDetail